import {Component, effect, input, output} from '@angular/core';
import {TaListBase} from '../../../pages/ta-list-base.directive';
import {BasicTaDetails, FullTaDetails} from '../../../../api';
import {Button} from 'primeng/button';
import {DatePipe, NgClass} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {InputText} from 'primeng/inputtext';
import {TableModule} from 'primeng/table';
import {Checkbox} from 'primeng/checkbox';
import {PrepaidIndicatorComponent} from '../../prepaid-indicator/prepaid-indicator.component';
import {AttachmentIndicatorComponent} from '../../attachment-indicator/attachment-indicator.component';
import {TaCostBubbleComponent} from '../../ta-cost-bubble/ta-cost-bubble.component';
import {TaCommentCount} from '../../ta-comments/ta-comment-count';
import {taPaymentComponents} from '../../../../util/general.utils';

@Component({
  selector: 'finance-requires-action-list',
  imports: [
    TaCommentCount,
    Button,
    DatePipe,
    FormsModule,
    InputText,
    NgClass,
    TableModule,
    Checkbox,
    PrepaidIndicatorComponent,
    AttachmentIndicatorComponent,
    TaCostBubbleComponent,
  ],
  templateUrl: './finance-requires-action-list.component.html',
  styleUrl: './finance-requires-action-list.component.scss',
})
export class FinanceRequiresActionListComponent extends TaListBase {
  availableListInput = input<BasicTaDetails[]>([]);
  finaliseTaClicked = output<FullTaDetails>();
  finaliseSelectedClicked = output<BasicTaDetails[]>();

  constructor() {
    super();
    effect(() => {
      this.availableTaList.set(this.availableListInput());
    });
  }

  protected readonly taPaymentComponents = taPaymentComponents;
}
